// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c91c8b6c","455":"55ab36a0"}[chunkId] + ".chunk.js";
};